import { useEffect } from "react";
import { getADFSLoginUrl } from "../../store/apis/authApi";

function NewLoginPage2(props) {

  useEffect(() => {
  }, [])
  const handleADFSLoginCLick = async () => {

    try {
      const redirectUrl = await getADFSLoginUrl();
      if (!redirectUrl) {
        throw new Error("Redirect URL not received");
      }
      // Required for ADFS / OAuth
      window.location.assign(redirectUrl);
    } catch (error) {
      console.error("ADFS login failed:", error);
      alert("Unable to login. Please try again.");
    }
  };
  const handleDealerLoginCLick = () => {
    props.nav('/dealerlogin')
  }
  /////////////////////Remove this after development//////////////////////////



// const wildCard = () =>{
//   axios({
//     method:'POST',
//     data:{
//       userid:'kpmg_pnikhil',
//     },
//     withCredentials:true,
//     url:Login_url
//   })
//   .then((results)=>{
//       console.log(results.data);
//        if(results.data?.token){
//         // if(results.data?.access==='Yes'){ setMapAccess(true); }
//         // if(results.data?.admin==='Yes'){ setAdminAccess(true); }
//         // if(results.data?.report==='Yes'){setReportAccess(true); }
//         // setMessage(`Hello, ${results.data.Name}`);
//         // console.log("Saving....");
//         localStorage.setItem("token", JSON.stringify(results.data["token"]));
//         localStorage.setItem("userInfo",JSON.stringify(_.omit(results.data,["token"])));
//           props.nav('/gis')
//       }
//       else{
//         // setMessage("Some error exception happened");
//       }
//   })
// }





  ////////////////////////END//////////////////////////////////////////////////

return (
  <div>
    <section
      style={{
        backgroundImage: " url(background.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <div className="flex justify-center items-center py-3">
        <img src="marutilogo.png" className="h-[84px] w-auto max-w-[360px] object-contain" alt="Logo" />
      </div>
      <div className="flex justify-center items-center pb-2">
        <img src="ruralmaps.png" className="w-80 h-auto" alt="Logo" />
      </div>
      <div className="flex justify-center items-center bg-no-repeat pb-3 pt-2">
        <img src="powered-by-logo.png" alt="Logo" />
      </div>
      <div className="flex justify-center items-center pt-2">
        <img src="loginas.png" alt="Logo" />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="px-40 py-30">
          <button onClick={handleDealerLoginCLick} className="relative">
            <img src="rec1.png" alt="Image 1" className="relative" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <img src="dealer.png" alt="Image 2" />
              </div>
              <div className="absolute bottom-0 w-full text-center text-white font-roboto font-semibold py-4">
                DEALER
              </div>
            </div>
          </button>
        </div>
        <div className="px-40 py-30">

          <button onClick={handleADFSLoginCLick}   className="relative">
            <img src="rec1.png" alt="Image 1" className="relative" />
            <div className="absolute inset-0 flex items-center justify-center">
              <button className="relative">
                <img src="employee.png" alt="Image 2" />
              </button>
              <div className="absolute bottom-0 w-full text-center text-white font-roboto font-semibold py-4">
                EMPLOYEE
              </div>
            </div>
          </button>
        </div>

      </div>
    </section>
  </div>
);
}


export default NewLoginPage2;
